<template>
  <label
    :for="$attrs.for"
    class="mb-1 inline-block text-sm"
  >
    <slot />
  </label>
</template>
